package com.zaurh.mapquizwebsite.presentation.screen.daily_reward

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.zaurh.mapquizwebsite.domain.model.toDailyRewardAction
import com.zaurh.mapquizwebsite.domain.repository.DailyRewardsRepository
import com.zaurh.mapquizwebsite.presentation.screen.home.MainSideEffect
import com.zaurh.mapquizwebsite.presentation.screen.home.MainUIState
import com.zaurh.mapquizwebsite.utils.onError
import com.zaurh.mapquizwebsite.utils.onSuccess
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class DailyRewardsViewModel(
    private val dailyRewardsRepository: DailyRewardsRepository
) : ViewModel() {
    private val _uiState = MutableStateFlow(DailyRewardsUIState())
    val uiState = _uiState.asStateFlow()

    private val _sideEffect = MutableSharedFlow<DailyRewardsSideEffect>()
    val sideEffect = _sideEffect.asSharedFlow()

    fun onAction(action: DailyRewardsAction) {
        when (action) {
            DailyRewardsAction.OnInit -> {
                getDailyRewards()
            }

            DailyRewardsAction.OnClaimReward -> {
                viewModelScope.launch {
                    dailyRewardsRepository.claimDailyReward().onSuccess { result ->
                        getDailyRewards()
                    }.onError { code, message ->
                        println("dsjkadkj: $message")
                    }
                }
            }
        }
    }

    private fun getDailyRewards() {
        viewModelScope.launch {
            dailyRewardsRepository.getDailyRewards().onSuccess { result ->
                _uiState.update {
                    it.copy(
                        isLoading = false,
                        action = result.action.toDailyRewardAction(),
                        nextClaimAt = result.nextClaimAt,
                        dailyRewards = result.rewards
                    )
                }
            }.onError { code, message ->
            }
        }
    }
}

